import { useAction, useAtom } from '@reatom/npm-react'

import {
  NotificationBellIcon,
  NotificationBellOffIcon,
} from '@root/shared/ui-kit'

import {
  pushNotificationsEnabledAtom,
  pushSoundNotificationsActions,
} from '../../../atoms/reatom-alerts-notifications'

import { ToggleButton } from './wallet-alerts-dialog-common'

type Props = {}

export const WalletAlertsNotificationToggle: React.FC<Props> = () => {
  const [pushNotificationsEnabled] = useAtom(pushNotificationsEnabledAtom)
  const togglePushNotifications = useAction(pushSoundNotificationsActions)

  return (
    <ToggleButton
      data-active={pushNotificationsEnabled}
      size="xs"
      variant="soft"
      radius="rounded"
      iconRight={
        pushNotificationsEnabled ? (
          <NotificationBellIcon />
        ) : (
          <NotificationBellOffIcon />
        )
      }
      onClick={togglePushNotifications}
    />
  )
}
